<div class="table-wrapper">
  <div
    class="table-toolbar px-3"
    *ngIf="
      showDownload ||
      showFilter ||
      showReload ||
      showSearch ||
      getTemplateRef('addonRight') ||
      getTemplateRef('addonLeft')
    "
  >
    <ng-container
      *ngTemplateOutlet="getTemplateRef('addonLeft')"
    ></ng-container>
    <div
      *ngIf="showDownload || showReload || showFilter || showSearch"
      class="is-flex is-justify-content-end is-align-items-center ml-auto"
    >
      <div class="pr-4" *ngIf="showSearch">
        <input
          class="input is-small"
          type="text"
          (input)="handleSearch($event)"
          [value]="searchKeyword"
          [placeholder]="'SEARCH' | translate"
          [translationEditableModalDirective]="['SEARCH']"
        />
      </div>

      <div class="pr-4" *ngIf="showDownload && filtersApplied() > 0">
        <button
          class="button is-small is-table-toolbar-button"
          (click)="handleDownload()"
          [disabled]="isLoading"
          [ngClass]="isExporting ? 'is-loading' : ''"
        >
          <span class="is-small">
            <i class="fa-solid fa-download"></i>
          </span>
        </button>
      </div>

      <div
        class="pr-4"
        *ngIf="showFilter"
        (clickOutside)="handleClickOutside()"
      >
        <button
          class="button is-small is-table-toolbar-button"
          [ngClass]="{ 'is-active': filtersApplied() > 0 }"
          [disabled]="isLoading"
          (click)="toggleFilter()"
        >
          <span class="is-small">
            <i class="fa-solid fa-filter"></i>
          </span>
          <span
            *ngIf="filtersApplied() > 0"
            translationEditableDirective="FILTER"
            style="font-size: 14px"
            class="ml-2"
          >
            {{ filtersApplied() > 0 ? filtersApplied() : '' }}</span
          >
        </button>

        <form
          (ngSubmit)="onSubmit()"
          class="table-filters box"
          *ngIf="showFilters"
          [formGroup]="_filters"
          (click)="$event.stopPropagation()"
        >
          <div
            *ngIf="filterRows.controls.length"
            class="table-filter-rows"
            [ngClass]="{ 'single-filter': !allowMultipleFilters }"
            formArrayName="rows"
          >
            <div *ngFor="let row of filterRows.controls; let i = index">
              <div [formGroup]="row" class="table-filter-controls">
                <div class="table-filter-condition">
                  <span
                    translationEditableDirective="WHERE"
                    *ngIf="i === 0"
                    class="pr-2 is-size-7 has-text-weight-medium"
                    >{{ 'WHERE' | translate }}</span
                  >
                  <select
                    *ngIf="i && allowMultipleFilters"
                    [translationEditableModalDirective]="['OR', 'AND']"
                    formControlName="operator"
                    class="input is-small"
                  >
                    <option value="or">
                      {{ 'OR' | translate }}
                    </option>
                    <option value="and">
                      {{ 'AND' | translate }}
                    </option>
                  </select>
                </div>
                <div class="table-filter-control">
                  <select
                    [translationEditableModalDirective]="filterFieldsKeys"
                    formControlName="field"
                    class="input is-small"
                  >
                    <option
                      *ngFor="let field of filterFields"
                      [value]="field.filterKey || field.prop"
                    >
                      {{ field.name | translate }}
                    </option>
                  </select>
                </div>

                <div
                  class="table-filter-control"
                  *ngIf="isDate(row.get('type').value)"
                >
                  <input
                    class="input is-small"
                    type="date"
                    formControlName="range_from"
                  />
                </div>
                <div
                  class="table-filter-control"
                  *ngIf="isDate(row.get('type').value)"
                >
                  <input
                    class="input is-small"
                    type="date"
                    formControlName="range_to"
                  />
                </div>
                <div
                  class="table-filter-control"
                  *ngIf="!isDate(row.get('type').value) && !isBoolean(row.get('type').value)"
                >
                  <select
                    [translationEditableModalDirective]="
                      filterMatchingByType[getFieldType(row.get('field').value)]
                    "
                    formControlName="matching"
                    class="input is-small"
                  >
                    <option
                      *ngFor="
                        let match of filterMatchingByType[
                          getFieldType(row.get('field').value)
                        ]
                      "
                      [value]="match"
                    >
                      {{ match | translate }}
                    </option>
                  </select>
                </div>
                <div
                  class="table-filter-control"
                  *ngIf="isBoolean(row.get('type').value)"
                >
                  <select
                    formControlName="value"
                    class="input is-small"
                    [translationEditableModalDirective]="
                      getSelectTranslationKeys(row.get('field').value)
                    "
                    [translationEditableModalDirectiveDefaults]="
                      getSelectTranslationDefaults(row.get('field').value)
                    "
                  >
                    <option value=""></option>
                    <option
                      *ngFor="let value of getSelect(row.get('field').value)"
                      [value]="value.name"
                    >
                      {{
                        value.translationKey
                          | translate : { defaultValue: value.title }
                      }}
                    </option>
                  </select>
                </div>
                <div
                  class="table-filter-control"
                  *ngIf="isBoolean(row.get('type').value)"
                >
                </div>
                <div
                  class="table-filter-control"
                  *ngIf="!isDate(row.get('type').value) && !isBoolean(row.get('type').value)"
                >
                  <input
                    *ngIf="
                      !matchingIsEmpty(row.get('matching').value) &&
                      !isMatchingFixed(row.get('field').value)
                    "
                    class="input is-small"
                    type="text"
                    formControlName="value"
                  />
                  <select
                    formControlName="value"
                    class="input is-small"
                    *ngIf="isMatchingFixed(row.get('field').value)"
                    [translationEditableModalDirective]="
                      getSelectTranslationKeys(row.get('field').value)
                    "
                    [translationEditableModalDirectiveDefaults]="
                      getSelectTranslationDefaults(row.get('field').value)
                    "
                  >
                    <option value=""></option>
                    <option
                      *ngFor="let value of getSelect(row.get('field').value)"
                      [value]="value.name"
                    >
                      {{
                        value.translationKey
                          | translate : { defaultValue: value.title }
                      }}
                    </option>
                  </select>
                </div>
                <div>
                  <button
                    (click)="removeFilter(i)"
                    class="table-filter-remove p-1 pl-2"
                    type="button"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button
            *ngIf="allowMultipleFilters || (!allowMultipleFilters && filterRows.controls.length === 0)"
            type="button"
            (click)="addFilter()"
            class="table-filter-add button is-small"
          >
            <span class="icon is-small">
              <i class="fa-solid fa-plus"></i>
            </span>
            <span translationEditableDirective="ADD">{{
              'ADD' | translate
            }}</span>
          </button>
        </form>
      </div>

      <div class="" *ngIf="showReload">
        <button
          class="button is-small is-table-toolbar-button"
          (click)="handleRefresh()"
          [ngClass]="isLoading ? 'is-loading' : ''"
        >
          <span class="is-small">
            <i class="fa-solid fa-rotate-right"></i>
          </span>
        </button>
      </div>
    </div>

    <ng-container
      *ngTemplateOutlet="getTemplateRef('addonRight')"
    ></ng-container>
  </div>

  <div class="relative">
    <div class="spin" *ngIf="isLoading">
      <ng-lottie [options]="options" width="280px"></ng-lottie>
    </div>
    <div class="table-container">
      <table
        class="table is-hoverable is-striped"
        [ngClass]="{ loading: isLoading }"
      >
        <thead>
          <tr>
            <ng-container *ngFor="let column of columns">
              <th
                *ngIf="!column.hidden"
                [sortable]="column.sortable"
                (onSort)="handleSort($event)"
                [sortProp]="column.sortProp"
                [prop]="column.prop"
                [name]="column.name"
                [isSorted]="orderBy === column.prop"
                [sort]="sort"
                tableHeadColumn
              ></th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let index = index">
            <ng-container *ngFor="let column of columns">
              <td
                *ngIf="!column.hidden"
                [ngStyle]="{ width: column.width, 'max-width': column.maxWidth, 'white-space': column.maxWidth ? 'break-spaces' : null }"
                tableBodyColumn
              >
                <ng-template #defaultTemplate>
                  <span
                    [innerHTML]="
                      column.render
                        ? column.render(row.get(column.prop), row)
                        : row.get(column.prop)
                    "
                  ></span>
                </ng-template>
                <ng-container
                  *ngTemplateOutlet="
                    column.template
                      ? getTemplateRef(column.template)
                      : defaultTemplate;
                    context: { row: row, index: index }
                  "
                >
                </ng-container>
              </td>
            </ng-container>
          </tr>
          <tr *ngIf="rows.size == 0 && !isLoading">
            <td
              class="no-data"
              [attr.colspan]="columns.length"
              translationEditableDirective="NO_DATA"
            >
              <ng-container *ngIf="noDataTemplate">
                <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
              </ng-container>
              <span *ngIf="!noDataTemplate">{{ 'NO_DATA' | translate }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <nav
      *ngIf="!hideFooter"
      class="pagination table-nav"
      role="navigation "
      aria-label="pagination"
    >
      <div class="left">
        <span class="pagination-total">
          <span class="total-label" translationEditableDirective="SHOWING">{{
            'SHOWING' | translate
          }}</span
          >:
          <span *ngIf="totalResultsPassed">{{ totalResults | number }} of </span
          >{{ totalItems | number }}</span
        >
      </div>
      <div class="center is-flex is-align-items-center">
        <span class="pr-3">{{ 'ITEMS_PER_PAGE' | translate }}</span>
        <ng-select
          [items]="itemsPerPageOptions"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="handlePageSizeChange($event?.value)"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="parseInt(itemsPerPage)"
          class="is-small"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
        ></ng-select>
      </div>
      <div class="right is-flex is-justify-content-end">
        <div class="pages" *ngIf="pages > 1">
          <button
            [disabled]="(currentPage || 1) == 1"
            (click)="goToPrev()"
            class="pagination-previous button"
          >
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <div>
            <input
              class="input is-small p-0"
              [ngStyle]="{ width: pageInputWidth }"
              [value]="_currentPage || 1"
              (input)="handlePageChange($event)"
              (click)="handlePageInputClick($event)"
            />
            <span class="of" translationEditableDirective="OF">{{
              'OF' | translate
            }}</span>
            <span class="total_pages">{{ pages }}</span>
          </div>
          <button
            [disabled]="(currentPage || 1) == pages"
            (click)="goToNext()"
            class="pagination-next button"
          >
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </nav>
  </div>
</div>
